export default __webpack_public_path__ + "static/media/ApexchatLogo.46ff35fd.png";